import React from 'react'
import { ButtonLoadingSeeker, IconSeeker } from '@ui-seeker/core'
import { isCsvLoading } from '../../../../../@signals'


export default function UploadCsvTemplate() {


    return <ButtonLoadingSeeker
        sx={{ ml: 3 }}
        endIcon={<IconSeeker icon="file-zipper"/>}
        loading={isCsvLoading.value}
        onClick={e => {
            e.preventDefault()
            window.open('https://storage.googleapis.com/price-seeker-rentacar-reports-custom-csv/CustomCsvReportsTemplate.csv')
        }}
        tooltip="Download example template for CSV"
    >
        Download Example
    </ButtonLoadingSeeker>

}